export default __webpack_public_path__ + "static/media/221111_provider02.d199df69.pdf";